import React, { useRef } from "react";
import Styles from "./OngoingPopup.module.css";
import { Modal } from "@mui/material";
import { ReactComponent as Ongoing } from "../../../../assets/images/ongoing.svg";
import useOutsideClick from "../../../useOutsideClick";
const OngoingPopup = ({
  open,
  handleClose,
  onConfirm,
  contentText = "Ongoing",
  contentHeadText = "Your documentation is complete, and this",
  contentHead = "Ongoing",
  contentBottom = " You can now track your power transaction here.",
  buttonText = "Go To Ongoing",
}) => {
  const modalContentRef = useRef(null);

  // Handle click outside to close modal
  useOutsideClick(modalContentRef, handleClose);

  return (
    <div>
      <>
        <Modal
          open={open}
          onClose={handleClose}
          disableAutoFocus={true}
          disableEnforceFocus={true}
        >
          <div className={` ${Styles.createEditModalCont}`}>
            <div
              ref={modalContentRef}
              style={{ backgroundColor: " #ffffff", borderRadius: "32px" }}
              className={Styles.headerSection}
            >
              <div>
                <Ongoing />
              </div>
              <div
                className={`display_flex_row_center ${Styles.headerOngoing}`}
              >
                <span>Connection Moved to </span>
                <span>{contentHead}</span>
              </div>
              <div className={Styles.paraContent}>
                <span>{contentHeadText}</span>
                <span>
                  connection has been moved to{" "}
                  <span
                    style={{
                      fontWeight: "500",
                      color: "var(--primary-color-text",
                    }}
                  >
                    {contentText}
                  </span>{" "}
                  .
                </span>
                <span>{contentBottom}</span>
              </div>
              <div
                className={`display_flex_row_center ${Styles.ongoingButton}`}
              >
                <div
                  className={`display_flex_row_center  ${Styles.buttonCont}`}
                  onClick={onConfirm}
                  style={{ cursor: "pointer" }}
                >
                  {buttonText}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    </div>
  );
};

export default OngoingPopup;
